export default "__VITE_ASSET__1ba9ed20__"